import http from "../../../config/axios";

export const allUsers = () => {
    const res =  http.get('/admin/user')
    return res;
}

export const postUser = (user) => {
    const res =  http.post('/admin/user', user)
    return res;
}

export const patchUser = (user, email) => {
    const res =  http.patch(`/admin/user/${email}`, user)
    return res;
}

export const disableUser = (email) => {
    const res =  http.delete(`/admin/user/${email}`)
    return res;
}